import constant, { OWNER_AGENT_ROLES } from "./CommonConstants";

export const gotoDashboard = (props) => {
  const { userInfo } = props;
  let params = new URLSearchParams(props.router.location.search);
  const redirectTo = params.get("redirectTo");
  const isLeadFeedbackAgent = userInfo?.roles?.includes(constant.leadFeedbackAgent);
  const isHousingNeoAgent = userInfo?.roles?.includes(constant.housingNeoAgentRole);
  document.location.href = userInfo?.roles?.includes(
    constant.audienceMaximizerAgentRole
  )
    ? "/audience-maximizer"
    : isHousingNeoAgent
    ? "/housing-neo"
    : isLeadFeedbackAgent
    ? "/lead-feedback"
    : userInfo?.isFinanceUser
    ? "/incentive-payout"
    : userInfo?.isContentUserOnly
    ? "/content-package-page"
    : redirectTo
    ? redirectTo
    : "/home";
};

export const isOwnerAgentRole = (role) => OWNER_AGENT_ROLES.includes(role);

export const hasOwnerAgentRole = (roles) => Boolean(roles?.some(isOwnerAgentRole));

export const hasAssuredOwnerAgentRole = (roles) =>
  Boolean(roles?.includes(constant.housingAssuredAgentRole));

export const hasTMAgentRole = (roles) =>
  Boolean(roles?.includes(constant.housingTMAgentRole));

// Whether the agent's online/offline status lives in /mystique/v0/activity rather
// than /sapphire/v1/agents/status. Owner and tenant-monetization agents use it
// behind SAPPHIRE_OWNER_FLAG.
export const usesMystiqueActivityStatus = (roles) =>
  (hasTMAgentRole(roles) || hasOwnerAgentRole(roles)) &&
  Boolean(process.env.SAPPHIRE_OWNER_FLAG);
